export const TOGGLE_GLOSSARY = Symbol('TOGGLE_GLOSSARY')
export const TOGGLE_HEADER = Symbol('TOGGLE_HEADER')
export const TOGGLE_KEY_SHORTCUTS = Symbol('TOGGLE_KEY_SHORTCUTS')
export const FETCH_FAILED = Symbol('FETCH_FAILED')
export const UI_LOCALES_FETCHED = Symbol('UI_LOCALES_FETCHED')
export const CHANGE_UI_LOCALE = Symbol('CHANGE_UI_LOCALE')
export const DOCUMENT_SELECTED = Symbol('DOCUMENT_SELECTED')
export const LOCALE_SELECTED = Symbol('LOCALE_SELECTED')
export const STATS_FETCHED = Symbol('STATS_FETCHED')
export const HEADER_DATA_FETCHED = Symbol('HEADER_DATA_FETCHED')



// WEBPACK FOOTER //
// ./app/editor/actions/header-action-types.js